// LiveStatistics.jsx - FIXED VERSION
import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Badge, ProgressBar } from 'react-bootstrap';
import '../../../assets/css/home/LiveStatistics.css';

const LiveStatistics = () => {
  const [stats, setStats] = useState({
    totalDonations: 0,
    activeDonors: 0,
    registeredNGOs: 0,
    successfulDeliveries: 0
  });

  const [chartData, setChartData] = useState([
    { month: 'Jan', value: 0 },
    { month: 'Feb', value: 0 },
    { month: 'Mar', value: 0 },
    { month: 'Apr', value: 0 },
    { month: 'May', value: 0 },
    { month: 'Jun', value: 0 }
  ]);

  const [recentActivity, setRecentActivity] = useState([
    { id: 1, type: 'donation', donor: 'Ahmed Khan', amount: 5000, time: '2 mins ago', visible: false },
    { id: 2, type: 'ngo', name: 'Hope Foundation', action: 'Created campaign', time: '5 mins ago', visible: false },
    { id: 3, type: 'donation', donor: 'Sara Ali', amount: 3000, time: '8 mins ago', visible: false },
    { id: 4, type: 'delivery', receiver: 'Ali Raza', status: 'Completed', time: '12 mins ago', visible: false }
  ]);

  const canvasRef = useRef(null);
  const [hoveredStat, setHoveredStat] = useState(null);

  const targetStats = {
    totalDonations: 1247,
    activeDonors: 342,
    registeredNGOs: 89,
    successfulDeliveries: 1156
  };

  const targetChartData = [
    { month: 'Jan', value: 180 },
    { month: 'Feb', value: 220 },
    { month: 'Mar', value: 195 },
    { month: 'Apr', value: 260 },
    { month: 'May', value: 290 },
    { month: 'Jun', value: 310 }
  ];

  // Counter animation
  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setStats({
        totalDonations: Math.floor(targetStats.totalDonations * progress),
        activeDonors: Math.floor(targetStats.activeDonors * progress),
        registeredNGOs: Math.floor(targetStats.registeredNGOs * progress),
        successfulDeliveries: Math.floor(targetStats.successfulDeliveries * progress)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
        setStats(targetStats);
      }
    }, stepDuration);

    return () => clearInterval(timer);
  }, []);

  // Chart animation
  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setChartData(targetChartData.map(item => ({
        ...item,
        value: Math.floor(item.value * progress)
      })));

      if (currentStep >= steps) {
        clearInterval(timer);
        setChartData(targetChartData);
      }
    }, stepDuration);

    return () => clearInterval(timer);
  }, []);

  // Recent activity animation
  useEffect(() => {
    recentActivity.forEach((activity, index) => {
      setTimeout(() => {
        setRecentActivity(prev =>
          prev.map(item =>
            item.id === activity.id ? { ...item, visible: true } : item
          )
        );
      }, 500 + index * 300);
    });
  }, []);

  // Floating particles
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const particles = [];
    const particleCount = 30;

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        radius: Math.random() * 2 + 1,
        color: `rgba(255, 184, 0, ${Math.random() * 0.5 + 0.3})`
      });
    }

    let animationFrameId;

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(p => {
        p.x += p.vx;
        p.y += p.vy;

        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const getStatIcon = (type) => {
    switch (type) {
      case 'donations': return '💰';
      case 'donors': return '👥';
      case 'ngos': return '🏢';
      case 'deliveries': return '✅';
      default: return '📊';
    }
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'donation': return '💸';
      case 'ngo': return '🏢';
      case 'delivery': return '🚚';
      default: return '📋';
    }
  };

  const maxChartValue = Math.max(...chartData.map(d => d.value));

  return (
    <div className="don-live-statistics-section">
      <canvas ref={canvasRef} className="don-stats-particle-canvas"></canvas>

      <Container>
        {/* Section Header */}
        <div className="don-stats-header text-center mb-5">
          <div className="don-pulse-dot"></div>
          <h2 className="don-stats-title">
            <span className="don-live-badge">
              <span className="don-live-indicator"></span>
              LIVE
            </span>
            Donation Statistics
          </h2>
          <p className="don-stats-subtitle">Real-time impact tracking across the platform</p>
        </div>

        {/* ✅ FIX: g-4 gutter add kiya, h-100 cards ke liye */}
        <Row className="mb-5 g-4">
          <Col xl={3} lg={6} md={6} sm={12}>
            <Card
              className="don-stat-card don-stat-card-1 h-100"
              onMouseEnter={() => setHoveredStat('donations')}
              onMouseLeave={() => setHoveredStat(null)}
            >
              <Card.Body>
                <div className="don-stat-icon-wrapper">
                  <div className="don-stat-icon">{getStatIcon('donations')}</div>
                  <div className="don-stat-ripple"></div>
                </div>
                <div className="don-stat-number">
                  {stats.totalDonations.toLocaleString()}
                  <span className="don-stat-plus">+</span>
                </div>
                <div className="don-stat-label">Donations Completed</div>
                <div className="don-stat-trend">
                  <i className="bi bi-arrow-up-right"></i>
                  <span>+12% this month</span>
                </div>
                <div className="don-stat-glow don-stat-glow-1"></div>
              </Card.Body>
            </Card>
          </Col>

          <Col xl={3} lg={6} md={6} sm={12}>
            <Card
              className="don-stat-card don-stat-card-2 h-100"
              onMouseEnter={() => setHoveredStat('donors')}
              onMouseLeave={() => setHoveredStat(null)}
            >
              <Card.Body>
                <div className="don-stat-icon-wrapper">
                  <div className="don-stat-icon">{getStatIcon('donors')}</div>
                  <div className="don-stat-ripple"></div>
                </div>
                <div className="don-stat-number">
                  {stats.activeDonors.toLocaleString()}
                  <span className="don-stat-plus">+</span>
                </div>
                <div className="don-stat-label">Active Donors</div>
                <div className="don-stat-trend">
                  <i className="bi bi-arrow-up-right"></i>
                  <span>+8% this week</span>
                </div>
                <div className="don-stat-glow don-stat-glow-2"></div>
              </Card.Body>
            </Card>
          </Col>

          <Col xl={3} lg={6} md={6} sm={12}>
            <Card
              className="don-stat-card don-stat-card-3 h-100"
              onMouseEnter={() => setHoveredStat('ngos')}
              onMouseLeave={() => setHoveredStat(null)}
            >
              <Card.Body>
                <div className="don-stat-icon-wrapper">
                  <div className="don-stat-icon">{getStatIcon('ngos')}</div>
                  <div className="don-stat-ripple"></div>
                </div>
                <div className="don-stat-number">
                  {stats.registeredNGOs.toLocaleString()}
                  <span className="don-stat-plus">+</span>
                </div>
                <div className="don-stat-label">Registered NGOs</div>
                <div className="don-stat-trend">
                  <i className="bi bi-arrow-up-right"></i>
                  <span>+5 this month</span>
                </div>
                <div className="don-stat-glow don-stat-glow-3"></div>
              </Card.Body>
            </Card>
          </Col>

          <Col xl={3} lg={6} md={6} sm={12}>
            <Card
              className="don-stat-card don-stat-card-4 h-100"
              onMouseEnter={() => setHoveredStat('deliveries')}
              onMouseLeave={() => setHoveredStat(null)}
            >
              <Card.Body>
                <div className="don-stat-icon-wrapper">
                  <div className="don-stat-icon">{getStatIcon('deliveries')}</div>
                  <div className="don-stat-ripple"></div>
                </div>
                <div className="don-stat-number">
                  {stats.successfulDeliveries.toLocaleString()}
                  <span className="don-stat-plus">+</span>
                </div>
                <div className="don-stat-label">Successful Deliveries</div>
                <div className="don-stat-trend">
                  <i className="bi bi-arrow-up-right"></i>
                  <span>+18% today</span>
                </div>
                <div className="don-stat-glow don-stat-glow-4"></div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Charts Section */}
        <Row className="mb-5 g-4">
          {/* Bar Chart */}
          <Col lg={8} sm={12}>
            <Card className="don-live-chart-card h-100">
              <Card.Body>
                {/* Title row - top left */}
                <div className="don-chart-header mb-4">
                  <h5 className="don-live-chart-title">
                    <i className="bi bi-bar-chart-fill me-2"></i>
                    Monthly Donation Trends
                  </h5>
                  <span className="don-live-pulse-badge">
                    <span className="don-live-indicator-small"></span>
                    Live Data
                  </span>
                </div>

                <div className="don-bar-chart">
                  {chartData.map((item, index) => (
                    <div
                      key={index}
                      className="don-bar-wrapper"
                      style={{ '--bar-delay': `${index * 0.1}s` }}
                    >
                      <div
                        className="don-bar"
                        style={{
                          height: maxChartValue > 0 ? `${Math.max((item.value / maxChartValue) * 160, 8)}px` : '8px',
                          '--bar-color': `hsl(${180 + index * 20}, 70%, 50%)`
                        }}
                      >
                        <div className="don-bar-value">{item.value}</div>
                      </div>
                      <div className="don-bar-label">{item.month}</div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Recent Activity */}
          <Col lg={4} sm={12}>
            <Card className="don-activity-card h-100">
              <Card.Body>
                <div className="don-chart-header mb-4">
                  <h5 className="don-live-chart-title">
                    <i className="bi bi-clock-history me-2"></i>
                    Recent Activity
                  </h5>
                </div>

                <div className="don-activity-list">
                  {recentActivity.map((activity, index) => (
                    <div
                      key={activity.id}
                      className={`don-activity-item ${activity.visible ? 'don-visible' : ''}`}
                      style={{ '--activity-delay': `${index * 0.1}s` }}
                    >
                      <div className="don-activity-icon">
                        {getActivityIcon(activity.type)}
                      </div>
                      <div className="don-activity-content">
                        {activity.type === 'donation' && (
                          <>
                            <div className="don-activity-name">{activity.donor}</div>
                            <div className="don-activity-detail">
                              Donated Rs {activity.amount.toLocaleString()}
                            </div>
                          </>
                        )}
                        {activity.type === 'ngo' && (
                          <>
                            <div className="don-activity-name">{activity.name}</div>
                            <div className="don-activity-detail">{activity.action}</div>
                          </>
                        )}
                        {activity.type === 'delivery' && (
                          <>
                            <div className="don-activity-name">{activity.receiver}</div>
                            <div className="don-activity-detail">
                              Delivery {activity.status}
                            </div>
                          </>
                        )}
                        <div className="don-activity-time">{activity.time}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Progress Indicators */}
        {/* ✅ FIX: g-4 gutter add kiya */}
        <Row className="g-4">
          <Col lg={6} sm={12}>
            <Card className="don-progress-card h-100">
              <Card.Body>
                <div className="don-chart-header mb-4">
                  <h5 className="don-live-chart-title">
                    <i className="bi bi-bullseye me-2"></i>
                    Monthly Goal Progress
                  </h5>
                </div>

                <div className="don-goal-item mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-1">
                    <span className="don-goal-label">Donation Target</span>
                    <span className="don-goal-value">Rs 450K / Rs 500K</span>
                  </div>
                  <div className="don-custom-progress-bar">
                    <div className="don-progress-fill" style={{ width: '90%', backgroundColor: '#FFB800' }}></div>
                  </div>
                </div>

                <div className="don-goal-item mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-1">
                    <span className="don-goal-label">New Donors</span>
                    <span className="don-goal-value">342 / 400</span>
                  </div>
                  <div className="don-custom-progress-bar">
                    <div className="don-progress-fill" style={{ width: '85.5%', backgroundColor: '#165C5C' }}></div>
                  </div>
                </div>

                <div className="don-goal-item">
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-1">
                    <span className="don-goal-label">NGO Partnerships</span>
                    <span className="don-goal-value">89 / 100</span>
                  </div>
                  <div className="don-custom-progress-bar">
                    <div className="don-progress-fill" style={{ width: '89%', backgroundColor: '#1F7A7A' }}></div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6} sm={12}>
            <Card className="don-impact-card h-100">
              <Card.Body>
                <div className="don-chart-header mb-4">
                  <h5 className="don-live-chart-title">
                    <i className="bi bi-heart-fill me-2"></i>
                    Community Impact
                  </h5>
                </div>

                <div className="don-impact-grid">
                  <div className="don-impact-item">
                    <div className="don-impact-icon">🍞</div>
                    <div className="don-impact-number">1.2K</div>
                    <div className="don-impact-text">Families Fed</div>
                  </div>
                  <div className="don-impact-item">
                    <div className="don-impact-icon">💊</div>
                    <div className="don-impact-number">850</div>
                    <div className="don-impact-text">Medicines Provided</div>
                  </div>
                  <div className="don-impact-item">
                    <div className="don-impact-icon">📚</div>
                    <div className="don-impact-number">450</div>
                    <div className="don-impact-text">Students Helped</div>
                  </div>
                  <div className="don-impact-item">
                    <div className="don-impact-icon">🩸</div>
                    <div className="don-impact-number">320</div>
                    <div className="don-impact-text">Lives Saved</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LiveStatistics;